import { createContext, useContext, ReactNode } from 'react';
import { usePremium } from '@/hooks/usePremium';

interface PremiumContextType {
  isPremium: boolean;
  subscription: any | null;
  loading: boolean;
  subscribeToPremium: (planType: 'monthly' | 'yearly', paymentReference: string) => Promise<boolean>;
  cancelSubscription: () => Promise<boolean>;
  checkPremiumStatus: () => Promise<void>;
}

const PremiumContext = createContext<PremiumContextType | undefined>(undefined);

export const PremiumProvider = ({ children }: { children: ReactNode }) => {
  const premium = usePremium();

  return (
    <PremiumContext.Provider value={premium}>
      {children}
    </PremiumContext.Provider>
  );
};

export const usePremiumContext = () => {
  const context = useContext(PremiumContext);
  if (context === undefined) {
    throw new Error('usePremiumContext must be used within a PremiumProvider');
  }
  return context;
};